import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { SiteHeader } from './components/site-header';
import { SiteFooter } from './components/site-footer';

// Page imports
import Home from './pages/Home';
import Assessment from './pages/Assessment';
import Contact from './pages/Contact';
import Dashboards from './pages/Dashboards';
import Offerings from './pages/Offerings';
import OtSecurity from './pages/OtSecurity';
import TechnologyMapping from './pages/TechnologyMapping';

// Framework pages - India
import RbiFramework from './pages/frameworks/india/RbiFramework';
import DpdpaFramework from './pages/frameworks/india/DpdpaFramework';
import CertInFramework from './pages/frameworks/india/CertInFramework';
import SebiCscrfFramework from './pages/frameworks/india/SebiCscrfFramework';
import IrdaiFramework from './pages/frameworks/india/IrdaiFramework';

// Framework pages - International
import Iso27001Framework from './pages/frameworks/international/Iso27001Framework';
import PciDssFramework from './pages/frameworks/international/PciDssFramework';
import NistCsfFramework from './pages/frameworks/international/NistCsfFramework';
import DoraFramework from './pages/frameworks/international/DoraFramework';
import Nist80053Framework from './pages/frameworks/international/Nist80053Framework';

// Resource pages
import Resources from './pages/resources/Resources';
import Blog from './pages/resources/Blog';
import Blueprints from './pages/resources/Blueprints';
import Calculators from './pages/resources/Calculators';
import CaseStudies from './pages/resources/CaseStudies';
import ControlMaps from './pages/resources/ControlMaps';
import Webinars from './pages/resources/Webinars';
import Whitepapers from './pages/resources/Whitepapers';

function App() {
  return (
    <div className="min-h-screen bg-background-primary font-sans antialiased">
      <div className="min-h-screen">
        <SiteHeader />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/dashboards" element={<Dashboards />} />
            <Route path="/offerings" element={<Offerings />} />
            <Route path="/ot-security" element={<OtSecurity />} />
            <Route path="/technology-mapping" element={<TechnologyMapping />} />
            
            {/* India Frameworks */}
            <Route path="/frameworks/india/rbi" element={<RbiFramework />} />
            <Route path="/frameworks/india/dpdpa" element={<DpdpaFramework />} />
            <Route path="/frameworks/india/cert-in" element={<CertInFramework />} />
            <Route path="/frameworks/india/sebi-cscrf" element={<SebiCscrfFramework />} />
            <Route path="/frameworks/india/irdai" element={<IrdaiFramework />} />
            
            {/* International Frameworks */}
            <Route path="/frameworks/international/iso-27001" element={<Iso27001Framework />} />
            <Route path="/frameworks/international/pci-dss" element={<PciDssFramework />} />
            <Route path="/frameworks/international/nist-csf" element={<NistCsfFramework />} />
            <Route path="/frameworks/international/dora" element={<DoraFramework />} />
            <Route path="/frameworks/international/nist-800-53" element={<Nist80053Framework />} />
            
            {/* Resources */}
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/blog" element={<Blog />} />
            <Route path="/resources/blueprints" element={<Blueprints />} />
            <Route path="/resources/calculators" element={<Calculators />} />
            <Route path="/resources/case-studies" element={<CaseStudies />} />
            <Route path="/resources/control-maps" element={<ControlMaps />} />
            <Route path="/resources/webinars" element={<Webinars />} />
            <Route path="/resources/whitepapers" element={<Whitepapers />} />
          </Routes>
        </main>
        <SiteFooter />
      </div>
    </div>
  );
}

export default App;
